export const isAppLoaded = state => state.app.isLoaded;
export const isAppLoadingFailed = state => state.app.isLoadingFailed;
export const isAppLoading = state => state.app.isLoading;
export const isLowResolution = state => state.app.isLowResolution;
